import React from "react";
import { useThemeMode } from "../providers/AppThemeProvider";
import { getCssVariableValue } from "../utilities";

const getThemeColors = () => ({
    background: getCssVariableValue("--colors-grey-8"),
    text: getCssVariableValue("--colors-grey-1"),
});

export function useThemeColors() {
    const { mode } = useThemeMode();
    const [result, setResult] = React.useState(getThemeColors());

    // The CSS variables only update after a render cycle has completed,
    // so we have to rely on a useEffect hook + requestAnimationFrame
    // callback to fetch + update the colors after the render has occurred...
    React.useEffect(() => {
        requestAnimationFrame(() => setResult(getThemeColors()));
    }, [mode]);

    return result;
};